import { RouteConfig } from 'vue-router';

export function profileEditRoute(name: string): RouteConfig {
  return {
    path: 'edit',
    name,
    component: () => import(/* webpackChunkName: "ProfileEdit" */ '@/views/mainRoute/profile/Edit.vue'),
    props: { edit: true },
    meta: {
      title: 'Edycja profilu'
    }
  };
}
